import {http} from './config/config-relation-register'

export default{
    listar:async(token)=>{
        return  http.get('pragas',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('pragas',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('pragas/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('pragas/'+item.id_pragas,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}